var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreparing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.2926,
    r: 25,
    fill: "#ED7117"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8765 24.1138L16.8956 30.4536L16.8956 17.774L27.8765 24.1138Z",
    fill: "#ED7117"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5666 16.4926H32.4666V25.7926H30.9166V12.2301H27.8166V25.7926H26.2666V10.2926H23.1666V25.7926H21.6166V12.6176H18.5166V29.6676H18.1291L15.0446 21.9176L11.4331 23.3436L16.0211 34.8756C17.5711 38.7506 21.3221 41.2926 25.4916 41.2926C31.0561 41.2926 35.5666 36.7821 35.5666 31.2176V16.4926Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparing);
export default __webpack_public_path__ + "static/media/preparing.7ba02aa471e352b6d844151ef525e5b0.svg";
export { ForwardRef as ReactComponent };